import React from "react"

export type TAssignmentStatsColumn =
  "rowindex" | "salesperson" | "active deals" | "activities" | "activities to won" | "win / lost" | "time to close"

export type TSalesPlansFiltering = ReturnType<typeof useSalesPlansFiltering>

export const useSalesPlansFiltering = (initialDate: string) => {
  const [startDate, setStartDate] = React.useState(initialDate)

  return {
    startDate,
    setStartDate,
  }
}

// Helper function to create chart data from sales intelligence data
export const createChartData = (twoMonthsAgo: number, oneMonthAgo: number, current: number) => {
  return [{uv: twoMonthsAgo}, {uv: oneMonthAgo}, {uv: current}]
}

// Helper function to handle null/undefined values with fallback
export const formatTableValue = (value?: number | null, suffix = "") => {
  return value != null ? `${value}${suffix}` : "--"
}
